import {useState, useEffect} from 'react'
import axios from 'axios'
import '../components/review.component.css'

import useTranslation from '../translation/hook'

import { useRouter } from '../state/route.state'
import{ useAuth } from '../state/auth.state'
import {useAppState} from '../state/app.state'
import { Button } from './ui'
import { BASE_URL } from '../utils/helpers.util'

export default function ReviewRoute(props){

    const t = useTranslation()
    
    const [state, setState] = useState({
        item:null,
        generatingPreview: true,
        frontPreview: null
    })
    
    const {methods} = useRouter()
    const {methods:authMethods, state:authState} = useAuth()
    const {state:appState, methods:appMethods} = useAppState()
    
    const {cardType, cardMaterial, cardColor, cardText, selectedPattern, cardLogoBase64} = appState
    
    function generateFile(data){
        return new Promise((resolve, reject) => {
            const file = new FileReader()
            file.readAsDataURL(data)
            file.onload = function(){
                resolve(file)
            }
        })
    }
    
    
    async function generatePreview(item){
        try{
            const previewData = {
                item_type_id: item.id,
                item_pattern_id: cardType.patternSelection ? selectedPattern?.id ?? null : null,
                text: cardType.customText && cardText.length ? cardText : null
            }
            
            if(appState.cardLogoBase64) previewData.logo = appState.cardLogoBase64
            else {
                if(cardType.name === "pro")previewData.logo = "none"
            }
            
            const headerData = { 
                headers:{
                    Authorization: `Bearer ${authState.token}`
                },
                responseType: "blob"
            }
            const {data:frontData} = await axios.post(`${BASE_URL}/shop/card-preview-front`,previewData,headerData)
            const {data:backData} = await axios.post(`${BASE_URL}/shop/card-preview-back`,previewData,headerData)
            
            const backFile = await generateFile(backData)
            const file = new FileReader()
            file.readAsDataURL(frontData)
            file.onload = () => {
                
                setState(oldState => ({
                    ...oldState,
                    frontPreview: file.result,
                    backPreview:  backFile.result,
                    generatingPreview: false
                }))
                
            }
            
            
                        
        } catch(error){
            console.log(error)
        }
    }
    
    
    
    
    const price = appMethods.calculatePrice(state.item) / 100
    const shippingPrice = state.item?.shippingPrice / 100
    
    useEffect(() => {
        
        // const item = appState.items.find(item => {
            
        //     const material = item.material.indexOf(cardMaterial.type) > -1
        //     const isPvc = item.material === "ps"
        //     const type = isPvc ? item.material : (
        //         cardColor.name === "Nero" ? "mb" : "ms"
        //     )
            
        //     const color = isPvc ? item.color === cardColor.hex : true
            
        //     //B! ONE EDITION FILTER TO IMPLEMENT
        //     console.log(type, color)
        //     return material && item.material === type && color
        // })
        
        const item = appMethods.getItem()

        generatePreview(item)

        setState(oldState => ({
            ...oldState,
            item,
            loadingData: false,
        }))
        
        
        
    },[])
    
    
    async function buyItem(){
        const item = state.item

        let logo = cardType.customLogo && cardLogoBase64 != null ? cardLogoBase64 : "none"
        if(cardType.name === "basic") logo = null

        const reqData= {
            item_type_id: item.id,
            item_pattern_id: cardType.patternSelection ? selectedPattern?.id ?? null : null,
            text: cardType.customText ? cardText : null,
            logo,
            count: 1,
        }
        
        if(cardType.name=== "one edition"){
            reqData.logo = null
        }
    
        const headerData = { 
            headers:{
                Authorization: `Bearer ${authState.token}`
            },
        }
        
        
        const {data} = await axios.post(`${BASE_URL}/shop/transactions/items`, {
            items: [reqData]
        }, headerData) 
        
        
        const url = data.transaction_url
        
        methods.changeRoute("payment", {url})
        
    }
    
    
    if(state.generatingPreview) return (
        <div className="ordine-container">
            <div className="modal" style={{textAlign: "center", fontWeight: "bold", fontSize: 18}}>
                {t("site_pages_shop_app_generating_preview")}
            </div>
        </div>
    )
        
    return <div className="ordine-container">
        <div className="modal">
            <div className="modal-header" onClick={() => methods.changeRoute("app")}>
                <h3>{t("site_pages_shop_app_order_summary")}</h3>
            </div>
            <div className="preview-container">
                {!state.generatingPreview && (
                    <>
                        <div className="preview-image">
                            <img src={state.frontPreview} />
                        </div>
                        <div className="preview-image">
                            <img src={state.backPreview} />
                        </div>
                    </>
                )}
            </div>
            <div className="price-details">
                
                <div className="modal-paragraph">
                    {t("site_pages_shop_app_total")}: {price}€
                </div>
                <div className="modal-paragraph">
                    {t("")}
                </div>
            </div>
            <Button extraClass="login-button" onClick={buyItem} value={t("site_pages_shop_app_payment_button")}/>
            <div className="floating-back-button">
                    <Button value={t("site_pages_shop_app_back_button")} onClick={() => methods.changeRoute("app")}/>
                </div>
        </div>
    </div>
}
